import React from 'react';
import { STATUS_MAP, formatLabel } from '../../utils/constants';

const StatusBadge = ({ status }) => {
  const key = status?.toLowerCase().replace(/ /g, '_');
  const s = STATUS_MAP[key] || { bg: '#E5E7EB', color: '#4B5563' };
  return (
    <span style={{
      background: s.bg, color: s.color, padding: '4px 12px', borderRadius: 20,
      fontSize: 12, fontWeight: 600, letterSpacing: 0.3, whiteSpace: 'nowrap',
    }}>
      {formatLabel(status)}
    </span>
  );
};

export default StatusBadge;
